module.exports = __webpack_public_path__ + "static/img/group-img.969619e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/group-img.png
// module id = MPNP
// module chunks = 2